module.exports = __webpack_public_path__ + "img/logo.b531decb.svg";